import { $ } from '../../platform/dom';
import { MECHS } from '../../entities/mechs';
import { META } from '../../platform/storage';
import { RUN_LEN } from '../../sim/stage-flow';
import { newSeed, seedStr } from '../../core/rng';
import { P, equipMech } from '../../world/player';
import { registerScreen, resetFocus } from './router';
/* ============================================================
   作戰選擇 / 出擊準備（2026-08-05 第二版）
   ============================================================

   第一版是「AC6 式任務簡報」：左列任務、右側情報（戰場推移、預期接敵）。
   使用者兩次修正把那些欄位砍掉了 ——

     「戰場推移的機制已經被拿掉了」  → 四幕已經不存在，列它就是假資訊
     「也不需要寫預期接敵」          → Boss 時刻表是劇透也是噪音

   拿掉之後這一頁只剩三件事：打哪一關、開哪一台、用哪顆種子。
   所以主角換成**機體**：版型與機庫同一套（左欄清單、中央整塊留給自轉的 3D
   機體、右欄規格、底列動作），玩家在這裡回答的是「我要開哪一台去打」。

   選機體時**真的換模型**（`equipMech`）—— 中央那台就是等一下要開的那台，
   不然這個畫面等於在說謊。 */

export var RUN_CFG = { mech: 'chassis0', seed: 0 };

var OPS = [
  { code: 'OP.01', name: '廢域突破', locked: false,
    note: '從外圍機庫一路打到核心，20 分鐘後撤離。' },
  { code: 'OP.02', name: '熔核潛入', locked: true,
    note: '狹窄通道、無空戰空間 —— 推進系統會是負擔而不是優勢。' },
  { code: 'OP.03', name: '軌道降下', locked: true,
    note: '從高空投放，落點隨機。前三分鐘沒有補給。' },
];
var selOp = 0;

function mmss(sec: number) {
  var m = Math.floor(sec / 60), s = Math.floor(sec % 60);
  return m + ':' + (s < 10 ? '0' : '') + s;
}

function drawOps() {
  var html = '';
  OPS.forEach(function (o, i) {
    html += '<button class="opCard' + (o.locked ? ' locked' : '') + (i === selOp ? ' sel' : '') +
      '" data-op="' + i + '"' + (o.locked ? ' disabled' : '') + '>' +
      '<span class="opCode">' + o.code + '</span>' +
      '<span class="opName">' + o.name + (o.locked ? ' <i>LOCKED</i>' : '') + '</span>' +
      '<span class="opNote">' + o.note + '</span></button>';
  });
  $('opList').innerHTML = html;
  var bs = $('opList').querySelectorAll('.opCard');
  for (var i = 0; i < bs.length; i++) {
    (function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(b.getAttribute('data-op') || '0', 10);
        if (OPS[n].locked) return;
        selOp = n; drawOps(); drawMech();
      });
    })(bs[i]);
  }
}

/** 右欄：選中機體的規格 + 另一台的切換列。 */
function drawMech() {
  var m = MECHS[RUN_CFG.mech];
  var rows = [
    /* 「衝刺 2」那一格改成推進能量（2026-08-06）：衝刺已經沒有格數了，
       它跟飛行共用這條能量 —— 而能量上限正是兩者的共同尺度。 */
    ['結構', m.hp], ['護盾', m.sh], ['速度', m.speed], ['推進能量', m.thrustMax]
  ].map(function (r) {
    return '<div class="dstat"><span>' + r[0] + '</span><b>' + r[1] + '</b></div>';
  }).join('');
  var picks = Object.keys(MECHS).map(function (id) {
    var x = MECHS[id], un = META.mechs.indexOf(id) >= 0;
    return '<button class="dpick' + (id === RUN_CFG.mech ? ' sel' : '') + (un ? '' : ' locked') +
      '" data-m="' + id + '"' + (un ? '' : ' disabled') + '>' +
      '<b>' + x.name + '</b><span>' + (un ? x.cn : '未解鎖 · 累計擊墜 400 分') + '</span></button>';
  }).join('');
  $('opIntel').innerHTML =
    '<div class="dhead"><span>機體</span><small>UNIT</small></div>' +
    '<div class="dpicks">' + picks + '</div>' +
    '<p class="ddesc">' + m.desc + '</p>' +
    '<div class="dstats">' + rows + '</div>' +
    '<div class="dsec"><span class="eyebrow">武裝</span><div class="dkit">' +
    m.icons.map(function (k) { return '<i>' + k + '</i>'; }).join('') + '</div></div>' +
    '<div class="dsec"><span class="eyebrow">作戰</span>' +
    '<div class="dline"><span>' + OPS[selOp].name + '</span><b>' + mmss(RUN_LEN) + '</b></div>' +
    '<div class="dline"><span>威脅度</span><b class="hot">■■■□□</b></div>' +
    '<div class="dline"><span>出擊紀錄</span><b>' + (META.runs || 0) + ' 次' +
    (META.wins ? ' · 通關 ' + META.wins : '') + '</b></div></div>';

  var nm = $('dMechName'); if (nm) nm.textContent = m.name;
  var cn = $('dMechCn'); if (cn) cn.textContent = m.cn;

  var bs = $('opIntel').querySelectorAll('.dpick');
  for (var i = 0; i < bs.length; i++) {
    (function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-m');
        if (!id || META.mechs.indexOf(id) < 0) return;
        RUN_CFG.mech = id;
        if (P.rig) equipMech(id);          // 中央那台要真的換成選到的機體
        drawMech();
      });
    })(bs[i]);
  }
  resetFocus('screenBrief');
}

var startCb: ((mech: string, seed: number) => void) | null = null;
var footBound = false;
var registered = false;

/* 底列的三顆（返回／換種子／出擊）在 index.html 裡，**不隨重畫消失** ——
   所以只綁一次。重複綁會讓一次點擊觸發兩次出擊。 */
function bindFoot(onBack: () => void) {
  if (footBound) return;
  footBound = true;
  var rs = $('btnReseed');
  if (rs) rs.addEventListener('click', function () {
    RUN_CFG.seed = newSeed();
    var s = $('startSeed'); if (s) s.textContent = 'SEED ' + seedStr(RUN_CFG.seed);
  });
  var go = $('btnStart');
  if (go) go.addEventListener('click', function () { if (startCb) startCb(RUN_CFG.mech, RUN_CFG.seed); });
  var bk = $('btnBriefBack');
  if (bk) bk.addEventListener('click', onBack);
}

/** 打開。`onStart` / `onBack` 由 `screens/start.ts` 注入（避免 import hud 造成循環）。 */
export function openBrief(onStart: (mech: string, seed: number) => void, onBack: () => void) {
  if (!RUN_CFG.seed) RUN_CFG.seed = newSeed();
  startCb = onStart;
  drawOps(); drawMech();
  var s = $('startSeed'); if (s) s.textContent = 'SEED ' + seedStr(RUN_CFG.seed);
  bindFoot(onBack);
  if (!registered) {
    registered = true;
    registerScreen({ id: 'screenBrief', onEsc: onBack });
  }
  var st: any = $('screenStart'); if (st) st.classList.remove('show');
  var el: any = $('screenBrief'); if (el) el.classList.add('show');
  document.body.classList.add('deploy-on');
}

export function closeBrief() {
  var el: any = $('screenBrief'); if (el) el.classList.remove('show');
  document.body.classList.remove('deploy-on');
}
